module.exports = __webpack_public_path__ + "img/date.75ba4197.png";